import { useState } from "react";

interface SubmitData {
  location: be.Pud;
  creditCard?: be.CreditCard | be.TokenizedCreditCard;
  email?: string;
  faxNumber?: string;
  pudName?: string;
  telephone?: string;
  telephone2?: string;
}

export type OnSubmitData = SubmitData;

export function useFormSubmit(onSubmit: (data: SubmitData) => void) {
  const [submitting, setSubmitting] = useState(false);

  async function submit(data: SubmitData, pudId?: string) {
    setSubmitting(true);

    data.location.id = pudId ? pudId : undefined;
    data.location.email = data.email;
    data.location.faxNumber = data.faxNumber;
    data.location.pudName = data.pudName;
    data.location.telephone = data.telephone;
    data.location.telephone2 = data.telephone2;

    if (data.creditCard && !data.creditCard?.token && !data.creditCard?.numberLast4) {
      data.creditCard = {
        id: data.creditCard.id,
        address: data.creditCard.address,
        name: data.creditCard.name,
        number: data.creditCard.number,
        expiration: data.creditCard.expiration,
        postalCode: data.creditCard.postalCode,
      };
    }

    await onSubmit(data);
    setSubmitting(false);
  }

  return { submit, submitting };
}

export default useFormSubmit;
